import { PrimitiveTypes } from '@angular/cli/src/analytics/analytics-parameters';
import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  signal,
  WritableSignal
} from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR
} from '@angular/forms';

@Component({
  selector: 'app-checkbox',
  imports: [FormsModule],
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckboxComponent implements ControlValueAccessor {
  label: InputSignal<string> = input<string>('');
  isChecked: WritableSignal<boolean> = signal<boolean>(false);

  isDisabled: WritableSignal<boolean> = signal<boolean>(false);

  valueChange: OutputEmitterRef<boolean> = output<boolean>();

  onValueChange(event: Event) {
    const eventTarget: HTMLInputElement = event.target as HTMLInputElement;

    this.isChecked.set(eventTarget.checked);
    this.onChange(eventTarget.checked);
    this.valueChange.emit(eventTarget.checked);
    this.onTouched();
  }

  // ControlValueAccessor
  private onChange = (value: PrimitiveTypes | PrimitiveTypes[]) => {};
  onTouched = () => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.isDisabled.set(isDisabled);
  }

  writeValue(outsideValue: boolean = false): void {
    this.isChecked.set(outsideValue);
  }
}
